import { useState } from "react";
import "../blocks/modalWithForm/modalWithForm.css";
import ModalWithForm from "./ModalWithForm";

const AddFavoriteModal = ({ isOpen, onAddFavorite, handleCloseModal, isLoading }) => {
  const [type, setType] = useState("photo");
  const [url, setUrl] = useState("");
  const [title, setTitle] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onAddFavorite({ type, url, title });
  };

  return (
    <ModalWithForm
      buttonText="Add favorite"
      title="New favorite"
      onClose={handleCloseModal}
      isOpen={isOpen}
      onSubmit={handleSubmit}
    >
      <div className="modal__weather-type">
        <p className="modal__weather-title">What are you saving?</p>
        <div>
          <input
            type="radio"
            name="type"
            id="favorite-type-photo"
            value="photo"
            checked={type === "photo"}
            onChange={(e) => setType(e.target.value)}
          />
          <label htmlFor="favorite-type-photo">Photo</label>
        </div>
        <div>
          <input
            type="radio"
            name="type"
            id="favorite-type-video"
            value="video"
            checked={type === "video"}
            onChange={(e) => setType(e.target.value)}
          />
          <label htmlFor="favorite-type-video">Video</label>
        </div>
      </div>
      <label className="modal__label">
        {type === "photo" ? "Photo URL" : "Video URL"}
        <input
          type="url"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          name="url"
          className="modal__input"
          id="favorite-url-input"
          placeholder={type === "photo" ? "https://example.com/photo.jpg" : "https://youtube.com/watch?v=..."}
          required
        />
        <span className="modal__error"></span>
      </label>
      <label className="modal__label">
        Title (optional)
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          name="title"
          className="modal__input"
          id="favorite-title-input"
          placeholder="Give it a name"
          maxLength="60"
        />
        <span className="modal__error"></span>
      </label>
      <button type="submit" className="modal__submit-button_items">
        {isLoading ? "Adding..." : "Add favorite"}
      </button>
    </ModalWithForm>
  );
};

export default AddFavoriteModal;
